export var DocType;
(function (DocType) {
    DocType["InstagramPost"] = "instagram_post";
    DocType["CalendarEvent"] = "calendar_event";
    DocType["Logo"] = "logo";
    DocType["EmailDraft"] = "email_draft";
})(DocType || (DocType = {}));
//# sourceMappingURL=doc-type.const.js.map